import { Button } from "components/Button";
import { Input } from "components/Input/Input";
import { SelectLanguage } from "components/SelectLanguage";
import styled from "styled-components/macro";
import type { ElearningThemeInterface } from "themes/elearningInterface.theme";

interface Props {
  theme: ElearningThemeInterface;
}

export const StyledMenuInputs = styled.div<Props>`
  margin-top: 2rem;

  .info-component {
    display: flex;
    flex-direction: column;
    div {
      margin: 0.5rem 0;
    }
  }
`;

export const StyledButton = styled(Button)`
  margin-top: 1.5rem;

  .content {
    display: flex;
    column-gap: 0.5rem;
    align-items: center;
    justify-content: center;
  }
`;

export const StyledTitle = styled.title`
  display: flex;
  column-gap: 1rem;
  align-items: center;
  margin-bottom: 0.5rem;

  svg {
    color: ${({ theme }: Props) => theme.palette.neutral._500};
  }
`;

export const StyledInput = styled(Input)`
  height: 3rem;
  color: ${(props: Props) => props.theme.palette.neutral._500};
`;

export const StyledFieldSet = styled.div`
  margin-top: 1rem;
`;

export const StyledLanguageSelector = styled(SelectLanguage)`
  margin-top: 0;
`;
